export const COLUMN_TECHNOLOGY_NAME = "technologyName";

export const COLUMN_CATEGORY = "category";

export const COLUMN_SUB_CATEGORY = "subCategory";

export const COLUMN_STATUS = "status";

export const COLUMN_WORKING_PERIOD = "workingPeriod";

export const COLUMN_INSTALLATION_DATE = "installationDate";

export const COLUMN_REMOVED_PERIOD = "removedPeriod";

export const COLUMN_IS_FREE = "isFree";

export const COLUMN_IS_PAID = "isPaid";

export const COLUMN_DESCRIPTION = "description";
